import { useEffect } from 'react';
import type { QueryClient } from '@tanstack/react-query';

export const AUTH_EXPIRED_EVENT = 'auth:expired';

/**
 * Listens for the `auth:expired` event dispatched by the axios response
 * interceptor (see services/api.ts) when the backend returns 401. Without a
 * listener the event was dead: nothing cleared the React Query cache, so a new
 * session could briefly render the previous user's cached data.
 *
 * Token clearing and the redirect to /signin are already handled in api.ts; this
 * handler's job is to drop all cached query data on session expiry.
 */
export function useAuthExpiredHandler(queryClient: QueryClient): void {
  useEffect(() => {
    const handleAuthExpired = () => {
      queryClient.clear();
    };
    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
  }, [queryClient]);
}
